/** SectionTitle
 * Author: Robert Rolland
 * Date: Tuesday, July, 19, 2022
 * 
 * This component serves as the full width Grid item that has the Title of
 * the section with an underline for separation
 */

import React from "react";

import Grid from "@material-ui/core/Grid";
import colors from "../../assets/style/colors";

const SectionTitle = props => {

    return (
        <Grid item xs={12} style={{
            textTransform: "uppercase",
            fontWeight: "500",
            margin: "12px",
            padding: "0 0 4px 0",
            borderBottom: `solid 2px ${colors.black20}`
          }}>
          {props.children}
        </Grid>
    );
}

export default SectionTitle;